<template>
    <div
        class="file-drop-zone rounded-3 p-4 text-center bg-light border border-2 d-flex flex-column align-items-center justify-content-center gap-2"
        :class="{ 'drag-over border-primary bg-primary-subtle': isDragging }"
        @dragover.prevent="handleDragOver"
        @dragleave.prevent="handleDragLeave"
        @drop.prevent="handleDrop"
        @click="triggerFileInput"
    >
        <input
            ref="fileInput"
            type="file"
            accept="image/*,.pdf,application/pdf"
            multiple
            class="d-none"
            @change="handleFileSelect"
        />

        <i class="fa-solid fa-cloud-arrow-up fa-2x text-secondary"></i>
        <p class="mb-0 text-secondary">
            画像 / PDF をドラッグ&ドロップ または クリックして選択（複数可）
        </p>
    </div>
</template>

<script>
export default {
    emits: ['add'],

    data() {
        return {
            isDragging: false
        };
    },

    methods: {
        handleDragOver() {
            this.isDragging = true;
        },

        handleDragLeave() {
            this.isDragging = false;
        },

        handleDrop(event) {
            this.isDragging = false;
            this.emitAddFiles(event.dataTransfer?.files);
        },

        handleFileSelect(event) {
            this.emitAddFiles(event.target?.files);

            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
        },

        triggerFileInput() {
            this.$refs.fileInput?.click();
        },

        /**
         * FileList を配列化し、許可形式(画像/PDF)のみ抽出して add イベントで親へ返却する
         * 単一ファイル時も必ず File[] を返す
         * @param {FileList|null|undefined} file_list
         * @returns {void}
         */
        emitAddFiles(file_list) {
            const files_array = Array.from(file_list || []).filter((file_item) => this.isAllowedFile(file_item));

            if (files_array.length === 0) {
                return;
            }

            this.$emit('add', files_array);
        },

        /**
         * 対象ファイルが画像またはPDFか判定する
         * @param {File} file_item
         * @returns {boolean}
         */
        isAllowedFile(file_item) {
            const mime_type = (file_item.type || '').toLowerCase();
            const file_name = (file_item.name || '').toLowerCase();

            const is_image = mime_type.startsWith('image/');
            const is_pdf = mime_type === 'application/pdf' || file_name.endsWith('.pdf');

            return is_image || is_pdf;
        }
    }
};
</script>

<style scoped>
.file-drop-zone {
    min-height: 140px;
    cursor: pointer;
    border-style: dashed;
    transition: background-color 0.2s ease, border-color 0.2s ease;
}
</style>
